/** Help content ("How it works") for each condition and action type */

export const CONDITION_HELP_CONTENT: Record<string, { title: string; body: string }> = {
    keywords: {
        title: "Keyword",
        body: "Add keywords and select a match type to define how inbound messages will trigger the rule."
    },
    numbers: {
        title: "From Number",
        body: "Select the number(s) for which this rule should trigger. If no number is selected, the rule will apply to inbound messages from all numbers.",
    },
    countries: {
        title: "Countries",
        body: "Select the countries where this rule should trigger. If no country is selected, the rule will apply to inbound messages from all countries.",
    },
    schedule: {
        title: "Run Schedule",
        body: "Select a schedule to define when this rule should run. By default, this rule runs 24/7",
    },
    other: {
        title: "Condition",
        body: "Select the countries where this rule should trigger. If no country is selected, the rule will apply to inbound messages from all countries.",
    },
};

export const ACTION_HELP_CONTENT: Record<string, { title: string; body: string }> = {
    AutomatedResponse: {
        title: "Automated Response",
        body: "Send an automatic reply when the condition is met. You can use a template or compose a custom message. Optionally apply once per contact.",
    },
    NotifyUser: {
        title: "Notify User",
        body: "Enter or select an email address to receive notifications whenever a customer sends an inbound message and ensure you get these alerts promptly.",
    },
    CreateLead: {
        title: "Create Lead",
        body: "Create a new lead in CRM when an inbound message is received from a number not linked to an existing contact or lead. "
    },
    LogInCrm: {
        title: "Log in CRM",
        body: "Log the message in your linked CRM as notes or activities (depending on CRM support). Choose which records receive the log, optional filters, and Pipedrive-specific activity options when using activities.",
    },
    Delay: {
        title: "Delay",
        body: "Use this action to delay the next step in the rule for a specified time before the next action runs.",
    },
    default: {
        title: "Action",
        body: "Configure what happens when the condition is met.",
    },
};
